<template>
    <ElPopover
        placement="right-start"
        :popper-options="{ modifiers: [{ name: 'offset', options: { offset: [-200, 0] } }] }"
        width="300"
        trigger="hover"
        :open-delay="300"
        :show-arrow="false"
        popper-class="edition-upgrade-popover"
        :disabled="true"
    >
        <div data-theme="patsnapRD" :data-type="currentEditionPopoverType">
            <div class="mt-[-28px] -mx-4">
                <img src="../assets/icon/trail2upgrade.png" alt="" loading="lazy">
            </div>
            <div>
                <h3 class="text-[24px] font-bold mb-1 mt-3 text-eureka-600 leading-[32px]">
                    {{ t('packageDiff.singleAirUpgrade.title') }}
                </h3>
                <p class="text-sm text-gray-90">
                    {{ t('packageDiff.singleAirUpgrade.description') }}
                </p>
            </div>
            <ul class="flex flex-col gap-2 rounded-lg bg-gradient-to-b from-[#EDF4FC] to-[rgba(237,244,252,0.4)] p-3 my-2">
                <li v-for="(feature, key) in tm('packageDiff.singleAirUpgrade.features')" :key="key" class="flex text-sm text-grey-450 gap-1">
                    <PtIcon
                        :icon="SolidTickCircle"
                        class="th-btn-icon text-xl fill-eureka-500 flex-shrink-0"
                    />
                    <span v-html="feature" />
                </li>
            </ul>
            <button class="th-btn w-full th-btn-primary" @click="handleUpgrade">
                {{ t('packageDiff.singleAirUpgrade.buttonText') }}
            </button>
        </div>
        <template #reference>
            <div
                v-show="isEditionVisible"
                class="invisible lg:visible edition-upgrade-tag relative flex justify-end items-center w-full rounded-lg cursor-pointer"
                :class="{
                    'is-closed': !open,
                    'is-trial': hasTrialPackage,
                }"
                @click="handleUpgrade"
            >
                <template v-if="open">
                    <!-- <img class="absolute bottom-0 left-0 w-[120px] rounded-xl" src="../assets/icon/rocket.png" loading="lazy" />
                    <div class="flex flex-col gap-2 items-center relative z-10">
                        <span class="text-[12px] mr-1">
                            <span>{{ t('editionTag.freemium') }}</span>
                        </span>
                        <button class="edition-upgrade-btn text-xs th-btn py-[2px] pl-[4px] pr-[8px] bg-white/80 text-[#0764e9] active:!bg-white active:!shadow-none" @click.stop="handleUpgrade">
                            <UpgradeIcon class="th-btn-icon text-xl" />
                            {{ t('editionTag.upgrade') }}
                        </button>
                    </div> -->
                    <button class="th-btn th-btn-only-icon w-full bg-blue-40 hover:bg-[#DDEBF8] active:!bg-[#DDEBF8] text-eureka-600 text-xs">
                        <UpgradeIcon class="mr-1" />
                        {{ t('editionTag.upgrade') }}
                    </button>
                </template>
                <ElTooltip
                    v-else
                    effect="dark"
                    popper-class="pt-ui-tooltip"
                    :show-arrow="false"
                    :offset="32"
                    placement="right"
                    :content="t('editionTag.upgrade')"
                >
                    <UpgradeIcon class="th-btn-icon text-xl cursor-pointer focus:outline-none" />
                </ElTooltip>
            </div>
        </template>
    </ElPopover>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import { useI18n } from 'vue-i18n';
import { ElPopover, ElTooltip } from 'element-plus';
import UpgradeIcon from './icons/UpgradeIcon.vue';
import SolidTickCircle from '@patsnap-ui/icon/assets/solid/TickCircle.svg';
import { cn, en, jp, tw } from '../locales';
import { TrackEventType, TrackSourceType } from '../../../utils/track';

const props = defineProps<{
    open: boolean | undefined,
    onUpgrade?: () => void,
    ipNavService?: any,
}>();

const { t, tm } = useI18n({
    messages: {
        cn, en, jp, tw,
    },
});

// 纯样式默认值
const currentEditionPopoverType = 'free';
const isEditionVisible = true;
const hasTrialPackage = false;

function handleUpgrade() {
    // 埋点上报
    props.ipNavService?.track?.({
        event_type: TrackEventType.IpNavUpgradeClick,
        module_type: 'EUREKA',
        source_type: TrackSourceType.IpNavUpgrade,
        other_param: 'upgrade',
    });

    props.onUpgrade?.();
}

</script>

<style lang="scss">
.edition-upgrade-popover {
    border-radius: 20px 20px 8px 8px !important;
    padding: 0 16px 24px !important;
    border: none !important;
    text-align: left !important;
    word-break: normal !important;
    transform: translateX(28px);
}
.edition-upgrade-tag {
    // @apply mt-10;
    // margin-top: 16px;
    // background: linear-gradient(92.16deg, #E6F8DD 0%, #EDFCFF 27.51%, #DDF0F8 62.46%, #B9D9FF 99.92%);
    &.is-closed {
        @apply py-[6px] px-2 mt-0;
        background: white;
        width: auto;
    }

    &.is-trial {
        background: linear-gradient(92.16deg, #E6F8DD 0%, #EDFCFF 27.51%, #DDF0F8 62.46%, #B9D9FF 99.92%);
        @apply text-primary;
    }

  .edition-upgrade-btn {
    height: 24px;
    min-height: 24px;
    border: none;
    &:hover {
      box-shadow: 0px 0px 4px 0px rgba(7, 100, 233, 0.14), 0px 4px 8px 0px rgba(7, 100, 233, 0.08);
      background-color: white;
    }
  }
}
</style>
